// Debate-settled step animation geometry + timing (from debate-settled prototype).

/** Halftone trophy band behind the settled animation. */
export const DEBATE_SETTLED_BACKGROUND_SRC =
  '/images/support-mainnet/how-it-works-debate-settled-background.png' as const;

export const DEBATE_SETTLED_CARD = {
  width: 406,
  height: 450,
} as const;

/** Horizontal bleed room so the pill glow is not clipped by the artboard slot. */
export const DEBATE_SETTLED_SHADOW_GUTTER_X = 48;

export const DEBATE_SETTLED_ARTBOARD = {
  width: DEBATE_SETTLED_CARD.width + DEBATE_SETTLED_SHADOW_GUTTER_X * 2,
  height: DEBATE_SETTLED_CARD.height,
} as const;

export const DEBATE_SETTLED_TIMING = {
  pillPopMs: 0,
  pillOpenMs: 950,
  rewardMs: 1950,
  countUpDurationMs: 1100,
  intersectionThreshold: 0.4,
  minRewardAmount: 100,
  maxRewardAmount: 999.99,
} as const;

export const DEBATE_SETTLED_COPY = {
  outcomeLabel: 'Both sides cheat',
  prizeLabel: 'Prize pool',
  backerLabel: 'Backer rewards',
} as const;

export function easeOutCubic(progress: number): number {
  return 1 - (1 - progress) ** 3;
}

export function computeDebateSettledArtboardScale(
  containerWidth: number,
  containerHeight: number,
): number {
  if (containerWidth <= 0 || containerHeight <= 0) {
    return 1;
  }

  return Math.min(
    1,
    containerWidth / DEBATE_SETTLED_ARTBOARD.width,
    containerHeight / DEBATE_SETTLED_ARTBOARD.height,
  );
}

export function formatRewardAmount(amount: number): string {
  return `$${amount.toFixed(2)}`;
}

export function randomRewardAmount(): number {
  const { minRewardAmount, maxRewardAmount } = DEBATE_SETTLED_TIMING;
  return Math.random() * (maxRewardAmount - minRewardAmount) + minRewardAmount;
}

/** Stable preview amount for the resting frame before orchestrated playback runs. */
export function getDebateSettledRestingRewardAmount(): number {
  const { minRewardAmount, maxRewardAmount } = DEBATE_SETTLED_TIMING;
  return (minRewardAmount + maxRewardAmount) / 2;
}

/** Longest scripted timer plus count-up duration. */
export function getDebateSettledPlaybackDurationMs(): number {
  const { rewardMs, countUpDurationMs } = DEBATE_SETTLED_TIMING;
  return rewardMs + countUpDurationMs;
}
